<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="intro-text">
    <p>
      Tous les contrats d'assurances <strong>Mutuelle Santé Professionnelle</strong>, <strong>Prévoyance Professionnelle</strong>, 
      <strong>Emprunteur Crédit et Retraite</strong> pour assurer les maladies, les accidents, la maternité et le décès des 
      Professionnels et salariés d'Entreprises en France ou à l'étranger.
    </p>
  </div>

  <div class="insurance-grid">
    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-user-plus"></i>
      </div>
      <h3>Mutuelle Santé Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-globe"></i>
      </div>
      <h3>Mutuelle Santé Internationale</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-users"></i>
      </div>
      <h3>Mutuelle Santé Entreprise</h3>
    </div>

    <div class="insurance-card" (click)="navigateToPrevoyancePro()">
      <div class="icon-wrapper">
        <i class="pi pi-shield"></i>
      </div>
      <h3>Prévoyance Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-building"></i>
      </div>
      <h3>Prévoyance Entreprise</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-user"></i>
      </div>
      <h3>Retraite Complémentaire Professionnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-users"></i>
      </div>
      <h3>Retraite Complémentaire Entreprise</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-plane"></i>
      </div>
      <h3>Voyage Professionnel</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-question-circle"></i>
      </div>
      <h3>Je ne sais pas quel produit il me faut</h3>
    </div>
  </div>

  <div class="important-section">
    <h2>Très Important :</h2>
    <p>
      L'assurance des personnes correspond à la Protection Sociale des personnes de l'Entreprise. Vous assurez tout ce qui touche le personnel (et sa famille) sur tous les risques possibles d'atteinte à votre personne (et votre famille). Donc si vous souhaitez être correctement assuré alors il vous faudra :
    </p>
    
    <ol>
      <li>Assurer leur santé (Maladie, Hospitalisation, Indemnité journalière, Cure, Maternité, Frais de soins, Dentaire, Optique) en prenant en charge vos soins via une <a href="#" class="highlight-link">assurance Mutuelle Santé Professionnelle</a> via une <a href="#" class="highlight-link">assurance Mutuelle Santé Entreprise</a>.</li>
      
      <li>Et couvrir le risque de Prévoyance (le décès, les accidents mortels, les maladies graves tel les cancers, la vieillesse) en versant un capital décès au bénéficiaire désigné via une <a routerLink="/assurance-prevoyance-professionnelle" class="highlight-link">assurance Prévoyance Professionnelle</a> (PER INDIVIDUEL) ou une <a href="#" class="highlight-link">assurance Prévoyance Entreprise</a> (PER COLLECTIF).</li>
      
      <li>Puis préparer leur retraite via une <a href="#" class="highlight-link">assurance Complémentaire Retraite Professionnelle</a> (PER INDIVIDUEL) ou une <a href="#" class="highlight-link">assurance Complémentaire Retraite Entreprise</a> (PER COLLECTIF).</li>
      
      <li>Certains faits assurer les risques de déplacement professionnel (votre frais, rapatriement, annulation, bagages) d'un particulier lors d'un déplacement professionnel via une <a href="#" class="highlight-link">assurance Voyage Personnel</a>.</li>
      
      <li>Et enfin, garantir le crédit immobilier (Décès, PTIA, Incapacité / arrêt de travail, Invalidité professionnelle, MNO) en versant des mensualités de crédit en cas d'arrêt de travail via une <a href="#" class="highlight-link">assurance de Crédit – assurance Emprunteur</a>.</li>
    </ol>

    <p class="partners-note">
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong>GENERALI, MATMUT, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMAINS, ALPTIS, POP SANTÉ, FMA, ASAF & AFPS, HENNER, APVIA MACIF, AVENIR MUTUELLE, IDENTITÉ MUTUELLE, UCR, PRAECONIS,...</strong>
    </p>
  </div>

</app-page-layout>
